import {
  Person,
  EventBusy,
  Apartment,
  NotificationsActive,
  Assignment,
  Work,
  ReportProblem,
  Description,
  Accessible,
  ExitToApp,
  Public,
  WarningAmber,
  AccessTime,
  PunchClock,
  Restore,
  Payments,
  ReceiptLong,
  LocalHospital,
  School,
} from '@mui/icons-material';

export const tabs = [
  { name: 'Cadastro', icon: Assignment },
  { name: 'Pessoal', icon: Person },
  { name: 'Afastamento', icon: EventBusy },
  { name: 'Ambiente', icon: Apartment },
  { name: 'Aviso Prévio', icon: NotificationsActive },
  { name: 'Cargo', icon: Work },
  { name: 'CAT', icon: ReportProblem },
  { name: 'Contrato', icon: Description },
  { name: 'Deficiência', icon: Accessible },
  { name: 'Desligamento', icon: ExitToApp },
  { name: 'Estrangeiro', icon: Public },
  { name: 'Fator de Risco', icon: WarningAmber },
  { name: 'Horário', icon: AccessTime },
  { name: 'Ponto', icon: PunchClock },
  { name: 'Reintegração', icon: Restore },
  { name: 'Remuneração', icon: Payments },
  { name: 'Rúbrica', icon: ReceiptLong },
  { name: 'Saúde', icon: LocalHospital },
  { name: 'Treinamento', icon: School },
];
